import { countBy } from 'lodash';
import { Prefix } from 'ripe/common';
import { getPrefixRoutes } from 'ripe/lookingGlass';
import { AsyncReturnType } from 'type-fest';

export type PrefixVisibility = AsyncReturnType<typeof getPrefixVisibility>;

export const getPrefixVisibility = async (prefix: Prefix) => {
  const routes = await getPrefixRoutes(prefix);

  // No filters
  // Detects a lot of peers
  // const upstreamRoutes = routes;

  // Is transited
  // Detects peers that announces downstream
  // const upstreamRoutes = routes.filter(
  //   (route) =>
  //     route.asPath.length >= 3
  // );

  // >=5 hops
  // Ignores upstreams with big presence (few hops)
  // const upstreamRoutes = routes.filter((route) => route.asPath.length >= 5);

  // Is propagated to tier 1
  // Drops local transit?
  const upstreamRoutes = routes.filter(
    (route) => route.asPath.length >= 3 && route.asPath.some((hopAsn) => tierOneASNs.includes(hopAsn.toString())),
  );

  // >=6 peers seeing
  // Detects some big peers that announces downstream to a lot of customers
  // const upstreamRoutes = routes.filter(
  //   (route) =>
  //     route.asPath.length >= 3 &&
  //     routes.filter((otherRoute) => otherRoute.prefix === route.prefix && otherRoute.upstreamAsn === route.upstreamAsn)
  //       .length >= 6,
  // );

  return {
    prefix,
    transitedRouteCount: upstreamRoutes.length,
    routeCountByOriginAsn: countBy(routes, (route) => route.originAsn),
    routeCountByUpstreamAsn: countBy(upstreamRoutes, (route) => route.upstreamAsn),
  };
};
// 36924 35280 52863.
// 29467 35280 52863.
// 16347 35280 52863.
// 50903 35280 52863.
// 35426 35280 52863.

const tierOneASNs = [
  '7018', // AT&T
  '174', // CogentCo
  '209', // CenturyLink (Qwest)
  '3320', // Deutsche Telekom
  '3257', // GTT (Tinet)
  '3356', // Level3
  '3549', // Level3
  '1', // Level3
  '2914', // NTT (Verio)
  '5511', // Orange
  '6453', // Tata
  '6762', //Sparkle
  '12956', // Telefonica
  '1299', // TeliaSonera
  '701', // Verizon
  '702', // Verizon
  '703', // Verizon
  '2828', // XO
  '6461', //Zayo (AboveNet)
  '6963', // HE
  '3491', // PCCW
  '1273', // Vodafone (UK)
  '1239', // Sprint
  '2497', // Internet Initiative Japan
];
